<div class="block__right-side-panel">
    <div class="block-full-width no-padding no-border-radius">
        <div class="edit-profile-account">
            <div class="edit-profile-account-items-area">
                <h2 [ngClass]="{ 'margin-bottom-10': true }" tabindex="0">{{ 'YOUR_PASSWORD' | translate }}</h2>
                <p class="required-text">{{ 'REQUIRED_FIELDS_FORM_TITLE' | translate }}</p>

                <form [formGroup]="_passwordForm" (ngSubmit)="submitPassword()" ridangoFocusInvalidInput>
                    <input [formControl]="_passwordForm.controls.username" ridangoInput name="username" type="hidden" />

                    <div class="edit-profile-account-items-area__item">
                        <ridango-form-field class="form-margin-10">
                            <input
                                [formControl]="_passwordForm.controls.password"
                                ridangoInput
                                type="{{ showOldPassword ? 'text' : 'password' }}"
                                name="password"
                                required />
                            <ridango-label>{{ 'PH_OLD_PASSWORD' | translate }}</ridango-label>

                            <a
                                class="show-hide link link--action"
                                (click)="showOldPassword = !showOldPassword"
                                (keydown.enter)="showOldPassword = !showOldPassword"
                                (keydown.space)="showOldPassword = !showOldPassword"
                                tabindex="0"
                                role="button"
                                aria-hidden="true"
                                ridangoSuffix>
                                {{ showOldPassword ? ('HIDE' | translate) : ('SHOW' | translate) }}
                            </a>
                            <ridango-error
                                *ngIf="
                                    _passwordForm.controls.password.touched &&
                                    _passwordForm.controls.password.hasError('required')
                                ">
                                {{ 'LOCAL_INPUT_VALIDATION_REQUIRED' | translate }}</ridango-error
                            >
                        </ridango-form-field>
                    </div>

                    <div class="edit-profile-account-items-area__item">
                        <ridango-form-field class="form-margin-10">
                            <input
                                [formControl]="_passwordForm.controls.new_password"
                                ridangoInput
                                type="{{ showNewPassword ? 'text' : 'password' }}"
                                name="new_password"
                                required />

                            <ridango-label>{{ 'PH_NEW_PASSWORD' | translate }}</ridango-label>

                            <a
                                class="show-hide link link--action"
                                (click)="showNewPassword = !showNewPassword"
                                (keydown.enter)="showNewPassword = !showNewPassword"
                                (keydown.space)="showNewPassword = !showNewPassword"
                                tabindex="0"
                                role="button"
                                aria-hidden="true"
                                ridangoSuffix>
                                {{ showNewPassword ? ('HIDE' | translate) : ('SHOW' | translate) }}
                            </a>

                            <ridango-error
                                *ngIf="_passwordForm.controls.new_password.touched"
                                [ngSwitch]="
                                    getFirstError(_passwordForm.controls.new_password, [
                                        'required',
                                        'minlength',
                                        'numberRequired'
                                    ])
                                ">
                                <ng-container *ngSwitchCase="'required'">
                                    {{ 'LOCAL_INPUT_VALIDATION_REQUIRED' | translate }}
                                </ng-container>
                                <ng-container *ngSwitchCase="'minlength'">
                                    {{ 'LOCAL_INPUT_VALIDATION_MIN_LENGTH' | translate }}
                                </ng-container>
                                <ng-container *ngSwitchCase="'numberRequired'">
                                    {{ 'LOCAL_INPUT_PASSWORD_MISSING_NUMBER_LENGTH' | translate }}
                                </ng-container>
                            </ridango-error>
                        </ridango-form-field>
                    </div>

                    <div class="edit-profile-account-items-area__item">
                        <ridango-form-field class="form-margin-10">
                            <input
                                [formControl]="_passwordForm.controls.new_password_again"
                                ridangoInput
                                type="{{ showNewPasswordRepeat ? 'text' : 'password' }}"
                                name="new_password_again"
                                required />

                            <ridango-label>{{ 'PH_NEW_PASSWORD_AGAIN' | translate }}</ridango-label>

                            <a
                                class="show-hide link link--action"
                                (click)="showNewPasswordRepeat = !showNewPasswordRepeat"
                                (keydown.enter)="showNewPasswordRepeat = !showNewPasswordRepeat"
                                (keydown.space)="showNewPasswordRepeat = !showNewPasswordRepeat"
                                tabindex="0"
                                role="button"
                                aria-hidden="true"
                                ridangoSuffix>
                                {{ showNewPasswordRepeat ? ('HIDE' | translate) : ('SHOW' | translate) }}
                            </a>

                            <ridango-error
                                *ngIf="_passwordForm.controls.new_password_again.touched"
                                [ngSwitch]="
                                    getFirstError(_passwordForm.controls.new_password_again, [
                                        'required',
                                        'minlength',
                                        'numberRequired'
                                    ])
                                ">
                                <ng-container *ngSwitchCase="'required'">
                                    {{ 'LOCAL_INPUT_VALIDATION_REQUIRED' | translate }}
                                </ng-container>
                                <ng-container *ngSwitchCase="'minlength'">
                                    {{ 'LOCAL_INPUT_VALIDATION_MIN_LENGTH' | translate }}
                                </ng-container>
                                <ng-container *ngSwitchCase="'numberRequired'">
                                    {{ 'LOCAL_INPUT_PASSWORD_MISSING_NUMBER_LENGTH' | translate }}
                                </ng-container>
                            </ridango-error>
                        </ridango-form-field>
                    </div>

                    <div class="edit-profile-account-items-area__footer">
                        <div class="edit-profile-account-items-area__right">
                            <button class="btn btn--maximal btn--primary btn--big">
                                {{ 'BTN_CHANGE_PASSWORD' | translate }}
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>
